import { render, staticRenderFns } from "./metadata-thumbnail.vue?vue&type=template&id=452e4d81&scoped=true&"
import script from "./metadata-thumbnail.vue?vue&type=script&lang=js&"
export * from "./metadata-thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./metadata-thumbnail.vue?vue&type=style&index=0&id=452e4d81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e4d81",
  null
  
)

export default component.exports